angular.module('component-payments.format.expire.year.text', [])
	.directive('ctPaymentsFormatExpireYearText', paymentsFormatYearTextDirective);

paymentsFormatYearTextDirective.$inject = ['CtUtils'];
function paymentsFormatYearTextDirective(CtUtils) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: postLink
	};

	function postLink(scope, element, attr, ctrl) {
		element.on('keypress', onKeyPress);

		ctrl.$parsers.push(parser);

		function parser(value) {
			return value;
		}

		function onKeyPress(e) {
			var char = CtUtils.getChar(e);

			if (!char.match(/./)) {
				return;
			}

			if (!char.match(/\d/)) {
				e.preventDefault();
			}
		}
	}
}

module.exports = 'component-payments.format.expire.year.text';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/year-text.js
 ** module id = 95
 ** module chunks = 1
 **/